<template>
  <div class="app-page">
    <div class="outer">
      <div class="terms">
        <div class="header">
          <img class="logo" src="../assets/img/edgefirst_hexagon.svg">

          <h1>Terms and Conditions</h1>
        </div>

        <p><strong>Last Updated:</strong> Sept 2025</p>

        <p>These Terms and Conditions ("Terms") govern your use of EdgeFirst Studio ("Service", "Platform", or "We"), a SaaS platform for AI dataset management, model training, validation, and model downloads. By accessing or using the Service, you ("User" or "You") agree to be bound by these Terms. If you do not agree, do not use the Service.</p>

        <h2>1. Account Registration</h2>
        <ul>
          <li>You must register for an account to access and use EdgeFirst Studio.</li>
          <li>You agree to provide accurate, complete, and current information during registration.</li>
          <li>You are responsible for maintaining the confidentiality of your login credentials. Sharing your password or account access is strictly prohibited.</li>
        </ul>

        <h2>2. Acceptable Use</h2>
        <p>You agree <strong>not to</strong> use EdgeFirst Studio to:</p>
        <ul>
          <li>Engage in any malicious activity including, but not limited to, malware distribution, model poisoning, or adversarial attacks.</li>
          <li>Upload or use pirated, copyrighted, or otherwise unauthorized datasets or resources.</li>
          <li>Upload obscene, offensive, or illegal images, videos, or text.</li>
          <li>Share or distribute any public datasets provided by EdgeFirst Studio outside the platform.</li>
          <li>Attempt to probe, scan, or test the vulnerability of the platform or breach any security or authentication measures.</li>
          <li>Share your password or permit others to access the Service using your credentials.</li>
          <li>Reverse engineer, decompile, or disassemble any part of the platform.</li>
          <li>Use the Service in a manner that violates any applicable laws or regulations.</li>
        </ul>

        <h2>3. User Content</h2>
        <ul>
          <li>You retain ownership of the datasets and models you upload to the platform.</li>
          <li>By uploading data, you confirm that you have the necessary rights or permissions to use and process such data.</li>
          <li>EdgeFirst Studio is not liable for any damages or legal consequences arising from your uploaded content.</li>
        </ul>

        <h2>4. Public Datasets</h2>
        <ul>
          <li>Public datasets made available through the platform are provided <strong>for use within EdgeFirst Studio only</strong>.</li>
          <li>You may <strong>not copy, download, redistribute, or share</strong> public datasets outside the platform.</li>
          <li>Violation of this policy may result in suspension or termination of your account.</li>
        </ul>

        <h2>5. Intellectual Property</h2>
        <p>All intellectual property rights in the platform, including software, features, designs, and trademarks, belong to EdgeFirst Studio or its licensors. Nothing in these Terms transfers any ownership rights to you.</p>

        <h2>6. Security</h2>
        <p>We implement reasonable measures to protect your data and the platform. However, you should not share username and passwords with anyone.</p>

        <h2>7. Termination</h2>
        <p>We reserve the right to suspend or terminate your access to the Service, with or without notice, for any violation of these Terms or if required by law.</p>

        <h2>8. Limitation of Liability</h2>
        <p>EdgeFirst Studio shall not be liable for any indirect, incidental, special, or consequential damages, including loss of data, profits, or business opportunities.</p>

        <h2>9. Changes to Terms</h2>
        <p>We may update these Terms from time to time. Continued use of the Service after changes become effective means you agree to the revised Terms.</p>

        <h2>10. Governing Law</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of Alberta, Canada, without regard to its conflict of law provisions.</p>

        <h2>11. Contact</h2>
        <p>If you have any questions about these Terms, please contact us at:</p>
        <p>
          📧 <a href="mailto:support@edgefirst.ai">support@edgefirst.ai</a><br>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>

    .header {
        display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
    margin-bottom: 10px;
    }

    h1, h2 {
      color: #1a1a1a;
    }
    h1 {
      font-size: 32px !important;

      padding-bottom: 10px;
      margin-bottom: 20px;
    }
    h2 {
      font-size: 18px;
      margin-top: 30px;
    }
    p, li {
      font-size: 13px;
    }
    ul {
      margin-top: 10px;
    }
    a {
      color: #007BFF;
    }
    li {
        margin-left: 32px;
    }

.logo {
    width: 200px;
}

.app-page {
  overflow: visible;
  height: 100dvh;

  background-color: #250e81 !important;
  background-image: url("@/assets/img/blu-stripes.png") !important;
}
.outer {
    align-self: center;
    overflow: hidden;
    padding: 4px;
    background-color: white;
    margin: 50px;
    border-radius: 8px;
}
.terms {
  background-color: white;
  height: 100%;
  padding: 40px 100px 40px 100px;

  overflow: auto;

}

.contents {

    overflow: auto;
    height: fit-content;
}

</style>
